import React, { Component } from 'react';
import RDP_CONFIG from '../../config';
import uuidv1 from 'uuid/v1';
import { Rnd } from 'react-rnd';
import {UserService} from '../../services/user';
import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from "react-zoom-pan-pinch";
import { RDPDamWidget } from '../../components';
import './element-video-interactive-1.css';
import './element-video-interactive-1-edit.css';

export default class ElementVideoInteractive1Edit extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.observeVideoTime = this.observeVideoTime.bind(this);

    this.state = {
      "is_mounted": true,
      "active_mode": "preview",
      "current_time": null,
      "current_layer_duration": null,
      "current_layer_width": "1920px",
      "current_layer_height": "1080px",
      "current_layer_interaction": null,
      "render_initial_frame": true,
      "render_new_layer_options": false,
      "render_new_interaction_options": false,

      "edit_current_layer": this.props.content.layers.length > 0 ? this.props.content.layers[0].id : null,
      "selected_layer_video": null,
      
    }
  }

  handleChange(content) {
    this.props.onChange(content);
  }

  componentDidMount() {
    this.setInitialLayer();
  }

  setInitialLayer() {
    var _this = this;
    var content = this.props.content;
    this.setState({
      "edit_current_layer": content.layers[0].id
    }, function() {
      // document.getElementById(content.layers[0].id).play()
      _this.observeVideoTime()
    })
  }

  observeVideoTime() {
    var _this = this;
    var layer = this.getEditCurrentLayer();
    if (layer) {
      var video = document.getElementById(layer.id);

      // _this.checkInteractions(Number(video.currentTime.toFixed(0)))
      
      video.addEventListener("loadedmetadata", function() {
        var width = `${video.videoWidth}px`;
        var height = `${video.videoHeight}px`;
        var duration = video.duration;

        _this.setState({
          "is_mounted": false,
          "current_layer_width": width,
          "current_layer_height": height,
          "current_layer_duration": duration
        }, function() {
          setTimeout(function() {
            _this.setState({
              "is_mounted": true
            })
          }, 10)
        })
      }, false);

      video.addEventListener("timeupdate", () => {
        console.log(video.currentTime)
        _this.checkInteractions(Number(video.currentTime.toFixed(0)))
      });

    }
  }

  checkInteractions(time) {
    var _this = this;
    this.setState({
      "current_time": time
    })

    var layer = this.getEditCurrentLayer();
    var interactions = layer.interactions;

    for (var i = 0; i < interactions.length; i++) {
      var interaction = interactions[i];
      if (interaction.type === "hotspot" && interaction.breakpoint === time) {
        var video = document.getElementById(layer.id);
        video.pause();
      } else if (interaction.type === "automatic" && interaction.breakpoint === time) {
        _this.onInteractionClick(interaction)
      }
    }
  }

  getVideoUrl(video) {
    var accessToken = UserService.getUser().access_token;
    if (video.search("https://pocs.digitalpages.com.br/rdpcomposer/media/") === -1) {
      video += "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    };
    return video;
  }

  onInteractionClick(interaction) {
    var _this = this;
    var content = this.props.content;
    var layer = this.state.edit_current_layer;

    // var id = interaction.target.layer;
    // var videoElement = document.getElementById(id);
    // videoElement[0].pause()  // Pause video
    // videoElement.empty()     // Remove all <source> children
    // videoElement.remove()    // Removing the video element altogether

    if (interaction.target.layer !== "current") {
      this.setState({
        "edit_current_layer": content.layers.find(item => item.id === interaction.target.layer)
      }, function() {
        document.getElementById(interaction.target.layer).currentTime = interaction.target.time;
        if (interaction.target.autoplay) {
          document.getElementById(interaction.target.layer).play()
        }

        _this.observeVideoTime(interaction)
      })
    } else {
      document.getElementById(layer.id).pause()
      document.getElementById(layer.id).currentTime = interaction.target.time;
      document.getElementById(layer.id).play()
      // _this.observeVideoTime(interaction)
    }
    // "target": {
    //   "layer": layerTwoUid,
    //   "time": 0
    // }
  }

  onInitialFramePlay() {
    var content = this.props.content;
    document.getElementById(content.layers[0].id).play()
    this.setState({
      "render_initial_frame": false
    });
  }

  onEditLayerClick(layer) {
    var _this = this;
    this.setState({
      "current_layer_interaction": null,
      "edit_current_layer": layer.id,
      "is_mounted": false
    }, function() {
      setTimeout(function() {
        _this.setState({
          "is_mounted": true
        })
        _this.observeVideoTime();
      }, 10)
    })
  }

  getEditCurrentLayer() {
    return this.props.content.layers.find(layer => layer.id === this.state.edit_current_layer);
  }

  formatJSON(val = {}) {
    try {
      return JSON.stringify(val, null, 2)
    } catch {
      const errorJson = {
        "error": `非法返回${val}`
      }
      return JSON.stringify(errorJson, null, 2)
    }
  }

  handleEditorChange(value, event) {
    this.props.onChange(JSON.parse(value))
    console.log(JSON.parse(value));
  }

  onLayerVideoChange(asset) {
    var content = this.props.content;
    var layers = content.layers;
    for (var i = 0; i < layers.length; i++) {
      if (layers[i].id === this.state.selected_layer_video) {
        layers[i].layer_asset = asset;
      };
    };
    content.layers = layers;

    this.props.onChange(content);
    this.setState({
      "selected_layer_video": null
    })
  }
  
  toggleLayersOptions() {
    this.setState({
      "render_new_layer_options": !this.state.render_new_layer_options
    })
  }

  toggleInteractionOptions() {
    this.setState({
      "render_new_interaction_options": !this.state.render_new_interaction_options
    })
  }

  onAddLayerVideo() {
    var { content } = this.props;

    var obj = {
      "id": uuidv1(),
      "layer_type": "video",
      "layer_asset": "https://pocs.digitalpages.com.br/rdpcomposer/media/video-1/video-1.mp4",
      "interactions": []
    };

    this.toggleLayersOptions();
    
    content.layers.push(obj);
    this.props.onChange(content);
  }

  getVideoHeight() {
    const {
      current_layer_width,
      current_layer_height
    } = this.state;

    return `${(Number(current_layer_height.split("px")[0]) * (740 / Number(current_layer_width.split("px")[0]))) + 70}px`
  }

  getVideoStyle() {
    const {
      current_layer_width,
      current_layer_height
    } = this.state;

    return {
      width: current_layer_width,
      height: current_layer_height
    }
  }

  // QUANDO UMA INTERAÇÃO NO MENU LATERAL DIREITO É SELECIONADA
  onInteractionSelect(interaction) {
    this.setState({
      "current_time": Number(interaction.breakpoint)
    })

    var currentLayer = this.getEditCurrentLayer();
    if (currentLayer.layer_type === "video") {
      document.getElementById(currentLayer.id).currentTime = interaction.breakpoint;
    };
    
    this.setState({
      "current_layer_interaction": interaction.id
    })
  }
  
  onInteractionChangeBreakpoint(breakpoint) {
    this.setState({
      "current_time": Number(breakpoint)
    })

    var interaction = this.getEditCurrentLayer().interactions.find(item => item.id === this.state.current_layer_interaction);
    var content = this.props.content;
    var layers = content.layers;
    for (let i = 0; i < layers.length; i++) {
      var interactions = layers[i].interactions;
      for (let j = 0; j < interactions.length; j++) {
        if (interactions[j].id === interaction.id) {
          interactions[j].breakpoint = Number(breakpoint);
          if (layers[i].layer_type === "video") {
            document.getElementById(layers[i].id).currentTime = Number(breakpoint);
          };
        };
      };
    };

    content.layers = layers;

    this.props.onChange(content);
  }

  onInteractionChangeTargetLayer(value) {
    var interaction = this.getEditCurrentLayer().interactions.find(item => item.id === this.state.current_layer_interaction);
    var content = this.props.content;
    var layers = content.layers;
    for (let i = 0; i < layers.length; i++) {
      var interactions = layers[i].interactions;
      for (let j = 0; j < interactions.length; j++) {
        if (interactions[j].id === interaction.id) {
          interactions[j].target.layer = value;
        };
      };
    };

    content.layers = layers;

    this.props.onChange(content);
  }

  onInteractionChangeTargetTime(value) {
    var interaction = this.getEditCurrentLayer().interactions.find(item => item.id === this.state.current_layer_interaction);
    if (!interaction) return;
    var content = this.props.content;
    var layers = content.layers;
    for (let i = 0; i < layers.length; i++) {
      var interactions = layers[i].interactions;
      for (let j = 0; j < interactions.length; j++) {
        if (interactions[j].id === interaction.id) {
          interactions[j].target.time = value;
        };
      };
    };

    content.layers = layers;

    this.props.onChange(content);
  }

  onInteractionChangeType(value) {
    var interaction = this.getEditCurrentLayer().interactions.find(item => item.id === this.state.current_layer_interaction);
    var content = this.props.content;
    var layers = content.layers;
    for (let i = 0; i < layers.length; i++) {
      var interactions = layers[i].interactions;
      for (let j = 0; j < interactions.length; j++) {
        if (interactions[j].id === interaction.id) {
          interactions[j].type = value;
        };
      };
    };

    content.layers = layers;

    this.props.onChange(content);
  }

  onInteractionChangeSize(prop, value) {
    var interaction = this.getEditCurrentLayer().interactions.find(item => item.id === this.state.current_layer_interaction);
    var content = this.props.content;
    var layers = content.layers;
    for (let i = 0; i < layers.length; i++) {
      var interactions = layers[i].interactions;
      for (let j = 0; j < interactions.length; j++) {
        if (interactions[j].id === interaction.id) {
          interactions[j][prop] = Math.round(Number(value));
        };
      };
    };

    content.layers = layers;

    this.props.onChange(content);
  }

  removeInteraction() {
    var _this = this;
    var interactions = this.getEditCurrentLayer().interactions;
    interactions = interactions.filter(int => int.id !== this.state.current_layer_interaction);

    this.setState({
      "current_layer_interaction": null
    }, function() {
      var content = _this.props.content;
      var layers = content.layers;
      for (let i = 0; i < layers.length; i++) {
        if (layers[i].id === _this.getEditCurrentLayer().id) {
          layers[i].interactions = interactions;
        };
      };
  
      content.layers = layers;
  
      _this.props.onChange(content);
    })
  }

  onResizeInteraction(interaction, size, e) {
    var scale = 740 / Number(this.state.current_layer_width.split("px")[0]);

    this.onInteractionChangeSize("width", size.width.split("px")[0]);
    this.onInteractionChangeSize("height", size.height.split("px")[0]);
  }

  onMoveInteraction(interaction, x, y) {
    var scale = 740 / Number(this.state.current_layer_width.split("px")[0]);
    var scaleDifference = 1 - scale;

    this.onInteractionChangeSize("position_x", String(x));
    this.onInteractionChangeSize("position_y", String(y));
  }

  onAddInteraction(type) {
    var obj = {};
    if (type === "hotspot") {
      obj = {
        "id": uuidv1(),
        "type": "hotspot",
        "width": 250,
        "height": 250,
        "position_x": 0,
        "position_y": 0,
        "breakpoint": 0,
        "target": {
          "layer": "current",
          "time": 0,
          "autoplay": true
        }
      }
    } else if (type === "automatic") {
      obj = {
        "id": uuidv1(),
        "type": "automatic",
        "width": null,
        "height": null,
        "position_x": null,
        "position_y": null,
        "breakpoint": 0,
        "target": {
          "layer": "current",
          "time": 0,
          "autoplay": true
        }
      };
    }

    var currentLayer = this.getEditCurrentLayer();
    var content = this.props.content;
    var layers = content.layers;
    for (let i = 0; i < layers.length; i++) {
      if (layers[i].id === currentLayer.id) {
        layers[i].interactions.push(obj);
      };
    };

    content.layers = layers;
    this.props.onChange(content);

    this.onInteractionSelect(obj)

    this.toggleInteractionOptions();
  }

  fixMouseEvent = (event) => {
    var scale = 740 / Number(this.state.current_layer_width.split("px")[0]);

    event.preventDefault();
    event.stopPropagation();

    // Ajusta as coordenadas do mouse para considerar a escala
    Object.defineProperty(event, "clientX", {
      value: event.clientX / scale,
      configurable: true,
    });

    Object.defineProperty(event, "clientY", {
      value: event.clientY / scale,
      configurable: true,
    });

    return event;
  };

  getLayer(layerRef) {
    if (layerRef === "current") return this.getEditCurrentLayer();
    return this.props.content.layers.find(item => item.id);
  }

  onRemoveLayer(layerId) {
    var _this = this;
    var content = this.props.content;
    var layers = content.layers;
    var filtered = layers.filter(lay => lay.id !== layerId);

    setTimeout(function() {
      _this.onEditLayerClick(filtered[0]);
    }, 300);

    content.layers = filtered;
    this.props.onChange(content);
  }

  render() {
    var _this = this;
    const {
      is_mounted,
      active_mode,
      current_time,
      current_layer_width,
      current_layer_height,
      current_layer_duration,
      current_layer_interaction,
      render_initial_frame,
      render_new_layer_options,
      render_new_interaction_options,

      edit_current_layer,
      selected_layer_video
    } = this.state;

    let { content, editable } = this.props;

    var scale = 740 / Number(current_layer_width.split("px")[0]);
    var scaleDifference = (1 - scale);

    return <div className="element-video-interactive-1-edit">
      {edit_current_layer &&
        <>
          <div className="element-video-interactive-1-edit-layers">
            <div className="element-video-interactive-1-edit-layers-header">
              <h4 className="element-video-interactive-1-edit-layers-header-title">Camadas</h4>
              <span className="element-video-interactive-1-edit-layers-header-add-btn" onClick={() => this.toggleLayersOptions()}>Adicionar Camada</span>
            </div>
            <ul className="element-video-interactive-1-edit-layers-items">
              {content.layers.map(function (layer, index) {
                return <li key={index} className={`element-video-interactive-1-edit-layers-item ${edit_current_layer === layer.id ? "active" : ""}`} onClick={() => _this.onEditLayerClick(layer)}>
                  <div className="element-video-interactive-1-edit-layers-item-header">
                    <span className={`element-video-interactive-1-edit-layers-item-header-icon ${layer.layer_type}`}></span>
                    <span className="element-video-interactive-1-edit-layers-item-header-label">Camada {index + 1}</span>
                  </div>
                  <div className="element-video-interactive-1-edit-layers-item-layer-picker">
                    {layer.layer_type === "video" &&
                      <div className="element-video-interactive-1-edit-layers-item-layer-picker-video">
                        <video style={{
                          width: "96px",
                          height: "54px"
                        }} src={_this.getVideoUrl(layer.layer_asset)} muted autoPlay></video>
                        <div>
                          <span className="element-video-interactive-1-edit-layers-item-layer-picker-edit" onClick={() => _this.setState({"selected_layer_video": layer.id})}>Substituir</span>
                          <span className="element-video-interactive-1-edit-layers-item-layer-picker-remove" onClick={() => _this.onRemoveLayer(layer.id)}>Remover</span>
                        </div>
                      </div>
                    }
                  </div>
                </li>
              })}
            </ul>

            {render_new_layer_options &&
              <div className="element-video-interactive-1-edit-options">
                <div className="element-video-interactive-1-edit-options-header">
                  <button className="element-video-interactive-1-edit-options-header-back" onClick={() => this.toggleLayersOptions()}></button>
                  <span className="element-video-interactive-1-edit-options-header-title">Adicionar Camada</span>
                </div>
                <ul className="element-video-interactive-1-edit-options-items">
                  <li className="element-video-interactive-1-edit-options-item" onClick={() => this.onAddLayerVideo()}>
                    <span className="element-video-interactive-1-edit-options-item-icon video"></span>
                    <span className="element-video-interactive-1-edit-options-item-label">Vídeo</span>
                  </li>
                  <li className="element-video-interactive-1-edit-options-item inactive">
                    <span className="element-video-interactive-1-edit-options-item-icon image"></span>
                    <span className="element-video-interactive-1-edit-options-item-label">Imagem</span>
                    <span className="element-video-interactive-1-edit-options-item-embreve">(Em breve)</span>
                  </li>
                </ul>
              </div>
            }
          </div>

          {is_mounted &&
            <div className="element-video-interactive-1-edit-layer-asset" key={this.getEditCurrentLayer() && this.getEditCurrentLayer().id} style={{
              height: this.getVideoHeight()
            }}>
              {this.getEditCurrentLayer() && this.getEditCurrentLayer().layer_type === "video" &&
                <div className="element-video-interactive-1-edit-layer-asset-video-frame">
                  <TransformWrapper
                    key={this.getEditCurrentLayer().id}
                    initialScale={scale}
                    minScale={scale}
                    maxScale={scale}
                    centerOnInit={false}
                    doubleClick={{
                      "disabled": true
                    }}
                    disabled={true}
                  >
                    {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                      <>
                        <TransformComponent>
                          <div className="element-video-interactive-1-container">
                            {/* <video controls src={this.getVideoUrl(content.video)}></video> */}
                            <video controls key={this.getEditCurrentLayer().id} style={this.getVideoStyle()} id={this.getEditCurrentLayer().id} src={this.getVideoUrl(this.getEditCurrentLayer().layer_asset)}></video>


                            {this.getEditCurrentLayer().interactions.filter(int => int.breakpoint === current_time && int.id === current_layer_interaction && int.type === "hotspot").map(function (interaction, index) {
                              return <Rnd
                                resizeHandleWrapperClass="element-video-interactive-1-rnd-resize"
                                scale={scale}
                                size={{ width: interaction.width,  height: interaction.height }}
                                position={{ x: (interaction.position_x), y: (interaction.position_y) }}
                                onDrag={(e, position) => {
                                  e = _this.fixMouseEvent(e);
                                  _this.onMoveInteraction(interaction, position.x, position.y)
                                }}
                                onResize={(e, direction, ref, delta, position) => {
                                  e = _this.fixMouseEvent(e);
                                  _this.onMoveInteraction(interaction, position.x, position.y)
                                  _this.onResizeInteraction(interaction, {
                                    "width": ref.style.width,
                                    "height": ref.style.height
                                  }, e)
                                }}
                                bounds="parent"
                              >
                              </Rnd>
                            })}

                            {/* {render_initial_frame &&
                              <div className="element-video-interactive-1-initial-frame">
                                <button className="element-video-interactive-1-initial-frame-play" onClick={() => this.onInitialFramePlay()}></button>
                              </div>
                            } */}
                          </div>
                        </TransformComponent>
                      </>
                    )}
                  </TransformWrapper>
                  {current_layer_interaction &&
                    <div className="element-video-interactive-1-edit-interaction-timeline">
                      <span className="element-video-interactive-1-edit-interaction-timeline-title">Arraste o marcador azul para definir em qual ponto do vídeo a interação deverá ser exibida</span>
                      <input
                        key={current_layer_interaction}
                        defaultValue={this.getEditCurrentLayer().interactions.find(item => item.id === current_layer_interaction) && this.getEditCurrentLayer().interactions.find(item => item.id === current_layer_interaction).breakpoint}
                        type="range"
                        min="0"
                        max={current_layer_duration}
                        onChange={(e) => _this.onInteractionChangeBreakpoint(e.target.value)}
                      />
                    </div>
                  }
                </div>
              }
            </div>
          }

          <div className="element-video-interactive-1-edit-interactions">
            <div className="element-video-interactive-1-edit-interactions-header">
              <h4 className="element-video-interactive-1-edit-interactions-header-title">Interações</h4>
              <span className="element-video-interactive-1-edit-interactions-header-add-btn" onClick={() => this.toggleInteractionOptions()}>Adicionar Interação</span>
            </div>
            <ul className="element-video-interactive-1-edit-interactions-items">
              {this.getEditCurrentLayer() && this.getEditCurrentLayer().interactions.map(function (interaction, index) {
                // {
                //   "type": "hotspot",
                //   "width": 590,
                //   "height": 860,
                //   "position_x": 1035,
                //   "position_y": 220,
                //   "breakpoint": 93,
                //   "target": {
                //     "layer": layerThreeUid,
                //     "time": 0,
                //     "autoplay": true
                //   }
                // }
                return <li key={interaction.id + index} className={`element-video-interactive-1-edit-interactions-item ${current_layer_interaction === interaction.id ? "active" : ""}`} onClick={() => _this.onInteractionSelect(interaction)}>
                  <div className="element-video-interactive-1-edit-interactions-item-header">
                    {/* <span className={`element-video-interactive-1-edit-interactions-item-header-icon ${interaction.type}`}></span> */}
                    <span className="element-video-interactive-1-edit-interactions-item-header-label">Interação {index + 1}</span>
                    <span className="element-video-interactive-1-edit-interactions-item-header-select"></span>
                  </div>

                  <div className="element-video-interactive-1-edit-interactions-item-layers-select-group">
                    <span className="element-video-interactive-1-edit-interactions-item-layers-select-group-title">Tipo de Interação:</span>
                    <select defaultValue={interaction.type} className="element-video-interactive-1-edit-interactions-item-select" onChange={(e) => _this.onInteractionChangeType(e.target.value)}>
                      <option value="hotspot">Área Clicável</option>
                      <option value="automatic">Execução Automática</option>
                    </select>
                  </div>

                  <div className="element-video-interactive-1-edit-interactions-item-layers-select-group">
                    <span className="element-video-interactive-1-edit-interactions-item-layers-select-group-title">Redirecionar para:</span>
                    <select value={interaction.target.layer} className="element-video-interactive-1-edit-interactions-item-select" onChange={(e) => _this.onInteractionChangeTargetLayer(e.target.value)}>
                      <option value="current">Mesma Camada</option>
                      {content.layers.map(function (layer, index) {
                        return <option value={layer.id}>Camada {index + 1}</option>
                      })}
                    </select>

                    {_this.getLayer(interaction.target.layer).layer_type === "video" &&
                      <>
                        <span className="element-video-interactive-1-edit-interactions-item-layers-select-group-title">Iniciar em:</span>
                        <video
                          className="element-video-interactive-1-edit-interactions-item-layers-video-asset"
                          id={`layer-target-${interaction.id}`}
                          src={_this.getVideoUrl(_this.getLayer(interaction.target.layer).layer_asset)}
                          onTimeUpdate={(e) => {
                            var t = Number(e.target.currentTime.toFixed(0));
                            var rangeEl = document.getElementById(`layer-range-${interaction.id}`);
                            if (rangeEl) rangeEl.value = t;
                            var ti = document.getElementById(`layer-time-input-${interaction.id}`);
                            if (ti) ti.value = `${String(Math.floor(t / 60)).padStart(2, '0')}:${String(t % 60).padStart(2, '0')}`;
                          }}
                          onLoadedMetadata={(e) => {
                            e.target.style.height = e.target.clientHeight + "px";
                            e.target.currentTime = Number(interaction.target.time);
                            var duration = e.target.duration;
                            var rangeEl = document.getElementById(`layer-range-${interaction.id}`);
                            if (rangeEl) rangeEl.setAttribute("max", duration);
                          }}
                          onPlay={() => {
                            document.getElementById(`layer-player-${interaction.id}`).classList.add("playing");
                          }}
                          onPause={() => {
                            document.getElementById(`layer-player-${interaction.id}`).classList.remove("playing");
                          }}
                          onSeeking={() => {
                            document.getElementById(`layer-player-${interaction.id}`).classList.remove("playing");
                          }}
                          preload
                        ></video>
                        <div
                          className="element-video-interactive-1-edit-interactions-item-layers-video-timeline"
                          id={`layer-player-${interaction.id}`}
                        >
                          <button className="element-video-interactive-1-edit-interactions-item-layers-video-timeline-play" onClick={() => document.getElementById(`layer-target-${interaction.id}`).play()}></button>
                          <button className="element-video-interactive-1-edit-interactions-item-layers-video-timeline-pause" onClick={() => document.getElementById(`layer-target-${interaction.id}`).pause()}></button>
                          <input
                            id={`layer-range-${interaction.id}`}
                            defaultValue={interaction.target.time}
                            type="range"
                            step="1"
                            min="0"
                            onChange={(e) => {
                              var seconds = Number(e.target.value);
                              var video = document.getElementById(`layer-target-${interaction.id}`);
                              video.currentTime = seconds;
                              _this.onInteractionChangeTargetTime(seconds);
                              var ti = document.getElementById(`layer-time-input-${interaction.id}`);
                              if (ti) ti.value = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
                            }}
                          />
                        </div>
                        <input
                          className="element-video-interactive-1-edit-interactions-item-layers-video-time-input"
                          id={`layer-time-input-${interaction.id}`}
                          type="text"
                          placeholder="MM:SS"
                          defaultValue={(() => {
                            var t = Number(interaction.target.time);
                            return `${String(Math.floor(t / 60)).padStart(2, '0')}:${String(t % 60).padStart(2, '0')}`;
                          })()}
                          maxLength={5}
                          onChange={(e) => {
                            var val = e.target.value.replace(/[^0-9]/g, '');
                            if (val.length > 2) val = val.slice(0, 2) + ':' + val.slice(2, 4);
                            e.target.value = val;
                            if (/^\d{2}:\d{2}$/.test(val)) {
                              var parts = val.split(':');
                              var seconds = Number(parts[0]) * 60 + Number(parts[1]);
                              var video = document.getElementById(`layer-target-${interaction.id}`);
                              video.currentTime = seconds;
                              document.getElementById(`layer-range-${interaction.id}`).value = seconds;
                              _this.onInteractionChangeTargetTime(seconds);
                            }
                          }}
                        />
                      </>
                    }
                  </div>


                  {interaction.type === "hotspot" &&
                    <div className="element-video-interactive-1-edit-interactions-item-sizes">
                      <div className="element-video-interactive-1-edit-interactions-item-sizes-input-group">
                        <span className="element-video-interactive-1-edit-interactions-item-sizes-input-label">
                          Largura:
                        </span>
                        <input
                          type="number"
                          value={interaction.width}
                          className="element-video-interactive-1-edit-interactions-item-sizes-input-field"
                          onChange={(e) => _this.onInteractionChangeSize("width", e.target.value)}
                        />
                        <span className="element-video-interactive-1-edit-interactions-item-sizes-input-px">px</span>
                      </div>
                      <div className="element-video-interactive-1-edit-interactions-item-sizes-input-group">
                        <span className="element-video-interactive-1-edit-interactions-item-sizes-input-label">
                          Altura:
                        </span>
                        <input
                          type="number"
                          value={interaction.height}
                          className="element-video-interactive-1-edit-interactions-item-sizes-input-field"
                          onChange={(e) => _this.onInteractionChangeSize("height", e.target.value)}
                        />
                        <span className="element-video-interactive-1-edit-interactions-item-sizes-input-px">px</span>
                      </div>
                      <div className="element-video-interactive-1-edit-interactions-item-sizes-input-group">
                        <span className="element-video-interactive-1-edit-interactions-item-sizes-input-label">
                          Posição X:
                        </span>
                        <input
                          type="number"
                          value={interaction.position_x}
                          className="element-video-interactive-1-edit-interactions-item-sizes-input-field"
                          onChange={(e) => _this.onInteractionChangeSize("position_x", e.target.value)}
                        />
                        <span className="element-video-interactive-1-edit-interactions-item-sizes-input-px">px</span>
                      </div>
                      <div className="element-video-interactive-1-edit-interactions-item-sizes-input-group">
                        <span className="element-video-interactive-1-edit-interactions-item-sizes-input-label">
                          Posição Y:
                        </span>
                        <input
                          type="number"
                          value={interaction.position_y}
                          className="element-video-interactive-1-edit-interactions-item-sizes-input-field"
                          onChange={(e) => _this.onInteractionChangeSize("position_y", e.target.value)}
                        />
                        <span className="element-video-interactive-1-edit-interactions-item-sizes-input-px">px</span>
                      </div>
                    </div>
                  }
                  <button className="element-video-interactive-1-edit-interactions-remove-btn" onClick={() => _this.removeInteraction()}>Remover Interação</button>
                </li>
              })}
            </ul>
            {render_new_interaction_options &&
              <div className="element-video-interactive-1-edit-options">
                <div className="element-video-interactive-1-edit-options-header">
                  <button className="element-video-interactive-1-edit-options-header-back" onClick={() => this.toggleInteractionOptions()}></button>
                  <span className="element-video-interactive-1-edit-options-header-title">Adicionar Interação</span>
                </div>
                <ul className="element-video-interactive-1-edit-options-items">
                  <li className="element-video-interactive-1-edit-options-item" onClick={() => this.onAddInteraction("hotspot")}>
                    <span className="element-video-interactive-1-edit-options-item-icon hotspot"></span>
                    <span className="element-video-interactive-1-edit-options-item-label">Área Clicável</span>
                  </li>
                  <li className="element-video-interactive-1-edit-options-item" onClick={() => this.onAddInteraction("automatic")}>
                    <span className="element-video-interactive-1-edit-options-item-icon automatic"></span>
                    <span className="element-video-interactive-1-edit-options-item-label">Execução Automática</span>
                  </li>
                </ul>
              </div>
            }
          </div>
        </>
      }
      {selected_layer_video &&
        <RDPDamWidget
          labels={this.props.labels}
          type="video"
          onClose={() => this.setState({"selected_layer_video": null})}
          onAssetChange={(asset) => this.onLayerVideoChange(asset)}
        />
      }
    </div>
  }
}
